import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { getRoles } from "../../../services/settings";
import Toggle from "../../../components/Toggle";
import { useAuth } from "../../../context/AuthContextProvider";
import BusinessName from "../../../components/BusinessName";

const UserList = ({ handleCancel, handleViewPermission }) => {
  const [roles, setRoles] = useState([]);
  const { globalProfile } = useAuth();

  const fetchRoles = async () => {
    try {
      const res = await getRoles();
      setRoles(res.data);
      console.log(res);
    } catch (error) {
      if (error.response) {
        toast.error(error.response.data.message);
      }
    }
  };

  useEffect(() => {
    fetchRoles();
  }, [globalProfile]);

  return (
    <div className="overflow-x-hidden">
      <div className="flex flex-col lg:flex-row items-start md:items-center justify-between">
        <h1 className="text-2xl font-bold text-navy-blue">
          Settings - Permission
        </h1>
        <Toggle />
      </div>

      {/* <section className="flex md:justify-end text-xl font-bold pt-4 mb-4 pr-4">
        <span className="ml-2">
          <BusinessName />
        </span>
      </section> */}

      <div className="w-full max-w-[1250px] min-h-screen xl:h-[1020px] bg-white mt-8 rounded-[10px] md:p-[3rem]">
        <div className="border border-gray-200 rounded-t-[10px] p-[1rem] pl-7 flex justify-between items-center">
          <p className="text-primary text-xl font-semibold">
            Add user permission
          </p>
          <span>
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M4.5 6.75L9 11.25L13.5 6.75"
                stroke="#464255"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>
        </div>

        <section className="flex justify-between items-center px-6 bg-white mt-8">
          <div className="md:text-4xl text-xl font-semibold">
            Here’s your list of user permission
          </div>
        </section>

        <article className="mt-8 flex flex-col md:flex-row md:flex-wrap w-full max-w-[1200px] px-4 md:px-8">
          {roles.map((role, index) => (
            <section
              key={role.id}
              className={`flex flex-col h-[200px] w-full md:w-[350px] p-4 ${
                index % 3 !== 2 ? "border-r" : ""
              } border-b justify-between`}
            >
              <div className="flex flex-col gap-4">
                <div className="text-lg font-medium">{role.name}</div>
              </div>

              <div className="flex justify-between items-center">
                <div
                  className="cursor-pointer text-sm font-medium text-primary"
                  onClick={() => handleViewPermission(role.id)}
                >
                  See permissions
                </div>
              </div>
            </section>
          ))}
        </article>
      </div>
    </div>
  );
};

export default UserList;
